import axiosBase from "@/api/axiosBase";

const state = {
  allProjectData: "",
  // 快速建模保存数据
  quickBuildSaveData: "",
  quickBuildSaveProjectData: "",
  // 数据配置
  configInfoData: "",
  // 选择的项目、分组信息
  retrievedData: "",
  // 保存新建模型的数据
  newModelData: "",
  // 选择上传的子流域数据
  selectSubbasinData: "",
  // 选择上传的子河道数据
  selectRiverData: "",
  // 选择上传的hru数据
  selectHruData: "",
  // 选择的dem数据
  selectDemData: "",
  selectHdgqData: "",
  // 选择子流域的坐标
  selectSubbasinXY: "",
  selecteRes: "",
  // 选择的用地数据
  selectLanduseData: "",
  // 选择的用地id
  selectLanduseId: "",
  // 选择的土壤数据
  selectSoilData: "",
  // 选择的土壤id
  selectSoilId: "",
  // 选择地形dem数据
  selectSlopeDEMData: "",
  // 选择的模版模型id
  templateModeleId: "",
  // 保存合并的数据
  mergeData: "",
  // 保存hru重分类数据
  hruMergeData: "",
  // 起始时间
  startTime: "",
  // 结束时间
  stopTime: "",
  // 模拟选择
  modelmodules: "",
  // 模拟水质组分
  qualMapping: "",
  // 模型的hru
  hruMapping: "",
  // 划分子流域数据step1
  subbasinData_Step1: "",
  // 划分子流域数据
  subbasinData_Step2: "",
  // 划分子流域数据
  subbasinData_Step2change: "",
  // 用地重分类表格数据
  groundReclassTbl: "",
  // 土壤重分类表格数据
  soilReclassTbl: "",
  soilReclassTbl_noinfile: "",
  // 坡度重分类数据
  slopeReclassData: "",

  // 重分类表格数据
  reclassTblData: "",

  upload_AutoDivide: false,
  // 记录是否切换
  isSwitch_dem: false,
  isSwitch_river: false,
  isSwitch_ground: false,
  isSwitch_soil: false,
  isSwitch_slope: false,

  file: "",
  continueModelData: "",
  selectTblModel: "",

  // 上传的hru文件数据
  uploadHruData: null,

  // 建模的步骤
  buildModelStep: "",
};

const getters = {
  // 保存所有的项目数据
  getSaveAllProjectData(state) {
    return state.allProjectData;
  },

  getRievedData(state) {
    return state.retrievedData;
  },

  // 保存快速建模选择的项目数据
  getQuickBuildSaveData(state) {
    return state.quickBuildSaveProjectData;
  },

  // 保存新建模型的数据
  getNewModelData(state) {
    return state.newModelData;
  },

  // 选择上传的子流域数据
  getSelectSubbasinData(state) {
    return state.selectSubbasinData;
  },

  // 选择上传的子河道数据
  getSelectRiverData(state) {
    return state.selectRiverData;
  },

  // 选择上传的hru数据
  getSelectHruData(state) {
    return state.selectHruData;
  },

  // 选择的dem数据
  getSelectDemData(state) {
    return state.selectDemData;
  },

  getSelectHdgqData(state) {
    return state.selectHdgqData;
  },

  // 选择子流域的坐标
  getSelectSubbasinXY(state) {
    return state.selectSubbasinXY;
  },

  getSelecteRes(state) {
    return state.selecteRes;
  },

  // 选择的用地数据
  getSelectLanduseData(state) {
    return state.selectLanduseData;
  },

  // 选择的用地id
  getSelectLanduseId(state) {
    return state.selectLanduseId;
  },

  // 选择的土壤数据
  getSelectSoilData(state) {
    return state.selectSoilData;
  },

  // 选择的土壤id
  getSelectSoilId(state) {
    return state.selectSoilId;
  },

  // 选择地形dem数据
  getSelectSlopeDEMData(state) {
    return state.selectSlopeDEMData;
  },

  // 选择的模版模型id
  getTemplateModeleId(state) {
    return state.templateModeleId;
  },

  // 保存合并的数据
  getMergeData(state) {
    return state.mergeData;
  },

  // 保存hru重分类数据
  getHruMergeData(state) {
    return state.hruMergeData;
  },

  // 起始时间
  getStartTime(state) {
    return state.startTime;
  },

  // 结束时间
  getStopTime(state) {
    return state.stopTime;
  },

  // 模拟选择
  getModelmodules(state) {
    return state.modelmodules;
  },

  // 模拟水质组分
  getQualMapping(state) {
    return state.qualMapping;
  },

  // 模型的hru
  getHruMapping(state) {
    return state.hruMapping;
  },

  // 划分子流域数据
  getSubbasinData_Step1(state) {
    return state.subbasinData_Step1;
  },

  // 划分子流域数据
  getSubbasinData_Step2(state) {
    return state.subbasinData_Step2;
  },

  // 划分子流域数据
  getSubbasinData_Step2change(state) {
    return state.subbasinData_Step2change;
  },

  // 用地重分类表格数据
  getGroundReclassTbl(state) {
    return state.groundReclassTbl;
  },

  // 土壤重分类表格数据
  getSoilReclassTbl(state) {
    return state.soilReclassTbl;
  },

  getSoilReclassTbl_noinfile(state) {
    return state.soilReclassTbl_noinfile;
  },

  // 坡度重分类数据
  getSlopeReclassData(state) {
    return state.slopeReclassData;
  },

  // 重分类表格数据
  getReclassTbl(state) {
    return state.reclassTblData;
  },

  // 记录划分子流域（本地上传、自动划分）模型
  getUpload_AutoDivide(state) {
    return state.upload_AutoDivide;
  },

  // 记录是否切换
  getIsSwitch_dem(state) {
    return state.isSwitch_dem;
  },
  getIsSwitch_river(state) {
    return state.isSwitch_river;
  },
  getIsSwitch_ground(state) {
    return state.isSwitch_ground;
  },
  getIsSwitch_soil(state) {
    return state.isSwitch_soil;
  },
  getIsSwitch_slope(state) {
    return state.isSwitch_slope;
  },

  getFile(state) {
    return state.file;
  },

  getContinueModelData(state) {
    return state.continueModelData;
  },

  getSelectTblModel(state) {
    return state.selectTblModel;
  },

  getUploadHruData(state) {
    return state.uploadHruData;
  },

  // 保存建模步骤
  getSaveModelStep(state) {
    return state.buildModelStep;
  },
};

const mutations = {
  // 保存快速建模（子流域子河道HRU边界条件）
  setSaveQuickBuild(state, data) {
    state.quickBuildSaveData = data;
  },

  // 保存快速建模选择的项目
  setSaveQuickBuildProject(state, data) {
    state.quickBuildSaveProjectData = data;
  },

  // 获取数据配置
  setGetConfigInfo(state, data) {
    state.configInfoData = data;
  },

  // 保存所有的项目数据
  setSaveAllProjectData(state, newMessage) {
    state.allProjectData = newMessage;
  },

  // 选择的项目、分组信息
  setRievedData(state, newMessage) {
    state.retrievedData = newMessage;
  },

  changeActProjectId(state, newMessage) {
    state.retrievedData.actProjectId = newMessage;
  },

  // 保存新建模型的数据
  setNewModelData(state, newMessage) {
    state.newModelData = newMessage;
  },

  // 选择上传的子流域数据
  setSelectSubbasinData(state, newMessage) {
    state.selectSubbasinData = newMessage;
  },
  // 选择上传的子河道数据
  setSelectRiverData(state, newMessage) {
    state.selectRiverData = newMessage;
  },

  // 选择上传的hru数据
  setSelectHruData(state, newMessage) {
    state.selectHruData = newMessage;
  },

  // 选择的dem数据
  setSelectDemData(state, newMessage) {
    state.selectDemData = newMessage;
  },

  setSelectHdgqData(state, newMessage) {
    state.selectHdgqData = newMessage;
  },

  // 选择子流域的坐标
  setSelectSubbasinXY(state, newMessage) {
    state.selectSubbasinXY = newMessage;
  },

  setSelecteRes(state, newMessage) {
    state.selecteRes = newMessage;
  },

  // 选择的用地数据
  setSelectLanduseData(state, newMessage) {
    state.selectLanduseData = newMessage;
  },

  // 选择的用地id
  setSelectLanduseId(state, newMessage) {
    state.selectLanduseId = newMessage;
  },

  // 选择的土壤数据
  setSelectSoilData(state, newMessage) {
    state.selectSoilData = newMessage;
  },

  // 选择的土壤id
  setSelectSoilId(state, newMessage) {
    state.selectSoilId = newMessage;
  },

  // 选择地形dem数据
  setSelectSlopeDEMData(state, newMessage) {
    state.selectSlopeDEMData = newMessage;
  },

  // 选择的模版模型id
  setTemplateModeleId(state, newMessage) {
    state.templateModeleId = newMessage;
  },

  // 保存合并的数据
  setMergeData(state, newMessage) {
    state.mergeData = newMessage;
  },

  // 保存hru重分类数据
  setHruMergeData(state, newMessage) {
    state.hruMergeData = newMessage;
  },

  // 起始时间
  setStartTime(state, newMessage) {
    state.startTime = newMessage;
  },

  // 结束时间
  setStopTime(state, newMessage) {
    state.stopTime = newMessage;
  },

  // 模拟选择
  setModelmodules(state, newMessage) {
    state.modelmodules = newMessage;
  },

  // 模拟水质组分
  setQualMapping(state, newMessage) {
    state.qualMapping = newMessage;
  },

  // 模型的hru
  setHruMapping(state, newMessage) {
    state.hruMapping = newMessage;
  },

  // 划分子流域数据
  setSubbasinData_Step1(state, newMessage) {
    state.subbasinData_Step1 = newMessage;
  },

  // 划分子流域数据
  setSubbasinData_Step2(state, newMessage) {
    state.subbasinData_Step2 = newMessage;
  },

  setSubbasinData_Step2change(state, newMessage) {
    state.subbasinData_Step2change = newMessage;
  },

  // 用地重分类表格数据
  setGroundReclassTbl(state, newMessage) {
    state.groundReclassTbl = newMessage;
  },

  // 土壤重分类表格数据
  setSoilReclassTbl(state, newMessage) {
    state.soilReclassTbl = newMessage;
  },

  setSoilReclassTbl_noinfile(state, newMessage) {
    state.soilReclassTbl_noinfile = newMessage;
  },

  // 坡度重分类数据
  setSlopeReclassData(state, newMessage) {
    state.slopeReclassData = newMessage;
  },

  // 重分类表格数据
  setReclassTbl(state, newMessage) {
    state.reclassTblData = newMessage;
  },

  // 记录划分子流域（本地上传、自动划分）模型
  setUpload_AutoDivide(state, newMessage) {
    state.upload_AutoDivide = newMessage;
  },

  // 记录是否切换
  setIsSwitch_dem(state, newMessage) {
    state.isSwitch_dem = newMessage;
  },
  setIsSwitch_river(state, newMessage) {
    state.isSwitch_river = newMessage;
  },
  setIsSwitch_ground(state, newMessage) {
    state.isSwitch_ground = newMessage;
  },
  setIsSwitch_soil(state, newMessage) {
    state.isSwitch_soil = newMessage;
  },
  setIsSwitch_slope(state, newMessage) {
    state.isSwitch_slope = newMessage;
  },

  setFile(state, newMessage) {
    state.file = newMessage;
  },

  // 保存继续建模的数据
  setContinueModelData(state, newMessage) {
    state.continueModelData = newMessage;
  },

  // 清空所有状态
  resetState(state) {
    state.quickBuildSaveData = "";
    state.quickBuildSaveProjectData = "";
    state.configInfoData = "";
    state.retrievedData = "";
    state.newModelData = "";
    state.selectSubbasinData = "";
    state.selectRiverData = "";
    state.selectHruData = "";
    state.selectDemData = "";
    state.selectHdgqData = "";
    state.selectSubbasinXY = "";
    state.selecteRes = "";
    state.selectLanduseData = "";
    state.selectLanduseId = "";
    state.selectSoilData = "";
    state.selectSoilId = "";
    state.selectSlopeDEMData = "";
    state.templateModeleId = "";
    state.mergeData = "";
    state.hruMergeData = "";
    state.startTime = "";
    state.stopTime = "";
    state.modelmodules = "";
    state.qualMapping = "";
    state.hruMapping = "";
    state.subbasinData_Step1 = "";
    state.subbasinData_Step2 = "";
    state.subbasinData_Step2change = "";
    state.groundReclassTbl = "";
    state.soilReclassTbl = "";
    state.soilReclassTbl_noinfile = "";
    state.slopeReclassData = "";
    state.reclassTblData = "";
    state.upload_AutoDivide = false;
    state.isSwitch_dem = false;
    state.isSwitch_river = false;
    state.isSwitch_ground = false;
    state.isSwitch_soil = false;
    state.isSwitch_slope = false;
    state.file = "";
    state.uploadHruData = null;
    state.buildModelStep = "";
  },

  // 清空继续建模的数据
  clearContinueModel(state) {
    state.continueModelData = "";
  },

  setSelectTblModel(state, newMessage) {
    state.selectTblModel = newMessage;
  },

  setUploadHruData(state, newMessage) {
    state.uploadHruData = newMessage;
  },

  // 保存建模步骤
  setBuildModelStep(state, newMessage) {
    state.buildModelStep = newMessage;
  },
};

const actions = {
  // 保存快速建模（子流域子河道HRU边界条件）
  saveQuickBuild({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/quickBuild/save",
        data: {
          modelId: data.modelId,
          subBasinRiver: data.subBasinRiver,
          hru: data.hru,
          boundary: data.boundary,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setSaveQuickBuild", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取数据配置
  getConfigInfo({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/build/dataConfigInfo/" + data,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setGetConfigInfo", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 保存所有的项目数据
  saveAllProjectData({ commit }, newMessage) {
    commit("setSaveAllProjectData", newMessage);
  },

  // 保存快速建模选择的项目
  saveQuickBuildSaveData({ commit }, newMessage) {
    commit("setSaveQuickBuildProject", newMessage);
  },

  // 选择的项目、分组信息
  saveretRievedData({ commit }, newMessage) {
    commit("setRievedData", newMessage);
  },

  // 修改保存的项目id
  changeProjectId({ commit }, newMessage) {
    commit("changeActProjectId", newMessage);
  },

  // 保存新建模型的数据
  saveNewModelData({ commit }, newMessage) {
    commit("setNewModelData", newMessage);
  },

  // 选择上传的子流域数据
  saveSelectSubbasinData({ commit }, newMessage) {
    commit("setSelectSubbasinData", newMessage);
  },

  // 选择上传的子河道数据
  saveSelectRiverData({ commit }, newMessage) {
    commit("setSelectRiverData", newMessage);
  },

  // 选择上传的hru数据
  saveSelectHruData({ commit }, newMessage) {
    commit("setSelectHruData", newMessage);
  },

  // 选择的dem数据
  saveSelectDemData({ commit }, newMessage) {
    commit("setSelectDemData", newMessage);
  },

  saveSelectHdgqData({ commit }, newMessage) {
    commit("setSelectHdgqData", newMessage);
  },

  // 选择子流域的坐标
  saveSelectSubbasinXY({ commit }, newMessage) {
    commit("setSelectSubbasinXY", newMessage);
  },

  saveSelecteRes({ commit }, newMessage) {
    commit("setSelecteRes", newMessage);
  },

  // 选择的用地数据
  saveSelectLanduseData({ commit }, newMessage) {
    commit("setSelectLanduseData", newMessage);
  },

  // 选择的用地id
  saveSelectLanduseId({ commit }, newMessage) {
    commit("setSelectLanduseId", newMessage);
  },

  // 选择的土壤数据
  saveSelectSoilData({ commit }, newMessage) {
    commit("setSelectSoilData", newMessage);
  },

  // 选择的土壤id
  saveSelectSoilId({ commit }, newMessage) {
    commit("setSelectSoilId", newMessage);
  },

  // 选择地形dem数据
  saveSelectSlopeDEMData({ commit }, newMessage) {
    commit("setSelectSlopeDEMData", newMessage);
  },

  // 选择的模版模型id
  saveTemplateModeleId({ commit }, newMessage) {
    commit("setTemplateModeleId", newMessage);
  },

  // 保存合并的数据
  saveMergeData({ commit }, newMessage) {
    commit("setMergeData", newMessage);
  },

  // 保存hru重分类的数据
  saveHruMergeData({ commit }, newMessage) {
    commit("setHruMergeData", newMessage);
  },

  // 起始时间
  saveStartTime({ commit }, newMessage) {
    commit("setStartTime", newMessage);
  },

  // 结束时间
  saveStopTime({ commit }, newMessage) {
    commit("setStopTime", newMessage);
  },

  // 模拟选择
  saveModelmodules({ commit }, newMessage) {
    commit("setModelmodules", newMessage);
  },

  // 模拟水质组分
  saveQualMapping({ commit }, newMessage) {
    commit("setQualMapping", newMessage);
  },

  // 选择的模拟水质组分
  saveSelectQualMapping({ commit }, newMessage) {
    commit("setSelectQualMapping", newMessage);
  },

  // 模型的hru
  saveHruMapping({ commit }, newMessage) {
    commit("setHruMapping", newMessage);
  },

  // 划分子流域数据step1
  saveSubbasinData_Step1({ commit }, newMessage) {
    commit("setSubbasinData_Step1", newMessage);
  },

  // 划分子流域数据
  saveSubbasinData_Step2({ commit }, newMessage) {
    commit("setSubbasinData_Step2", newMessage);
  },

  // 划分子流域数据
  saveSubbasinData_Step2change({ commit }, newMessage) {
    commit("setSubbasinData_Step2change", newMessage);
  },

  // 用地重分类表格数据
  saveGroundReclassTbl({ commit }, newMessage) {
    commit("setGroundReclassTbl", newMessage);
  },

  // 土壤重分类表格数据
  saveSoilReclassTbl({ commit }, newMessage) {
    commit("setSoilReclassTbl", newMessage);
  },
  saveSoilReclassTbl_noinfile({ commit }, newMessage) {
    commit("setSoilReclassTbl_noinfile", newMessage);
  },

  // 坡度重分类数据
  saveSlopeReclassData({ commit }, newMessage) {
    commit("setSlopeReclassData", newMessage);
  },

  // 重分类表格数据
  saveReclassTbl({ commit }, newMessage) {
    commit("setReclassTbl", newMessage);
  },

  // 记录划分子流域（本地上传、自动划分）模型
  saveUpload_AutoDivide({ commit }, newMessage) {
    commit("setUpload_AutoDivide", newMessage);
  },

  // 记录是否切换（dem、用地、土壤、坡度）模型
  saveIsSwitch_dem({ commit }, newMessage) {
    commit("setIsSwitch_dem", newMessage);
  },
  saveIsSwitch_river({ commit }, newMessage) {
    commit("setIsSwitch_river", newMessage);
  },
  saveIsSwitch_soil({ commit }, newMessage) {
    commit("setIsSwitch_soil", newMessage);
  },
  saveIsSwitch_ground({ commit }, newMessage) {
    commit("setIsSwitch_ground", newMessage);
  },
  saveIsSwitch_slope({ commit }, newMessage) {
    commit("setIsSwitch_slope", newMessage);
  },

  saveFile({ commit }, newMessage) {
    commit("setFile", newMessage);
  },

  // 保存继续建模的数据
  saveContinueModelData({ commit }, newMessage) {
    commit("setContinueModelData", newMessage);
  },

  // 保存模型首页表格选择的模型数据
  saveSelectModelList({ commit }, newMessage) {
    commit("setSelectTblModel", newMessage);
  },

  saveUploadHruData({ commit }, newMessage) {
    commit("setUploadHruData", newMessage);
  },

  // 保存建模步骤
  saveBuildModelStep({ commit }, newMessage) {
    commit("setBuildModelStep", newMessage);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
